import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';
import WindowBrowser from "../components/browser-window";

const Hardware = () => {
  useEffect(() => {
    // Any animations or side effects can be added here
  }, [])

  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Hardware</h1>
        <h3>Building the Detection System</h3>
      </div>

      <div class="max-w-2xl mx-auto mt-8">
        <div class="w-full h-11 rounded-t-lg bg-gray-900 flex justify-start items-center space-x-1.5 px-3">
          <span class="w-3 h-3 rounded-full bg-red-400"></span>
          <span class="w-3 h-3 rounded-full bg-yellow-400"></span>
          <span class="w-3 h-3 rounded-full bg-green-400"></span>
        </div>
        <div class="bg-gray-700 border-t-0 w-full h-96"></div>
      </div>

      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Hardware
            </div>

            <Scrollspy
              offset={-140}
              className="scrollspy" items={['Hardware', 'Design_Philosophy', 'Manufacturing']}
              currentClassName="active">
              <li><a href="#Hardware">Introduction to Hardware</a></li>
              <li><a href="#Design_Philosophy">Design Philosophy</a></li>
              <li><a href="#Manufacturing">Manufacturing & the operation principle</a></li>
              
            </Scrollspy>

            <img
              src="https://static.igem.wiki/teams/5334/wiki-images/updated-mascot/mascot-reading-book-light-4.webp"
              alt="Mascot reading the book"
              
            />
          </div>
        </div>

        <div className="main_lab_style">
          <WindowBrowser header="Introduction to Hardware" description={
            <div>
              <section id="Hardware">
                <p>
                The goal of the Bevatech’s test strip is to develop an aptasensor. After a literature research we designed a lateral-flow test strip, which consists of 4 major membrane pads, knowingly the sample pad where test solutions are inoculated, the conjugate pad where aptamer-linked gold-nanoparticles are immobilized for reaction with test solution upon present of target analyte, the main signaling membrane where it holds two lines, a test line and a control line in the respective order, and lastly an absorbent pad which its dimensions reflects the maximum capacity of test solution and helps to lower background by washing or essentially absorbing unbound liquids. These pads are sequentially laminated onto a plastic plate and encased in a plastic housing. The housing includes a sample port for easy application of the test solution onto the sample pad and an open window over the test-line membrane for clear signal visualization. The materials used and the dimensions of the device are carefully optimized to ensure a portable, rapid, and accurate testing experience, with a stable and prolonged shelf life. 
                </p>
                <img src="https://static.igem.wiki/teams/5334/wiki-images/lab/lfa.png"
                style={{
                    width: '60%', // Adjust width as needed
                    height: 'auto',
                    padding: '20px 160px'
                }}
                    ></img>
              </section>

              <section id="Design_Philosophy">
                <h1>Design Philosophy</h1>
                <p>
                In designing this device, we adhered to the principles of simplicity and accessibility for the end consumer. This is why we chose a form factor similar to the one used in COVID-19 rapid tests. This familiar format not only makes the device user-friendly but also ensures quick adoption by a wide audience, allowing for widespread use without the need for specialized training or equipment.
                </p>
              </section>

              <section id="Manufacturing">
                <h1>Manufacturing & the operation principle</h1>
                <p>
                Bevatech's lateral flow assay (LFA) device leverages nitrocellulose for the testing membrane. Nitrocellulosic fibers facilitate chemical bonding interactions between nitrate groups and peptides, enabling the signal display of bevacizumab and aptamer-linked nanoparticle conjugates. The dimensions of the strip are meticulously designed to optimize the loading capacity and capillary flow rate for the test solution containing the analyte.                
                </p>
                <p>The <strong>sample pad</strong> and <strong>absorbent pad</strong> are made from cellulose fiber filter paper, known for their large bed volumes (typically &gt;25 µL/cm²) and capacity to enhance the performance of the LFA by improving the reaction efficiency of the loaded test solution.
                </p>
                <p>The <strong>conjugate pad</strong> utilizes glass fiber filters and serves as the site for the immobilization of aptamer-linked gold nanoparticles, which are essential to the detection reaction. Upon loading the sample, if the target analyte (bevacizumab) is present, it competes with DNA probes at the test line to bind with the aptamer-Au particles at the conjugate pad due to their specific affinity. The conjugated sample then flows down the membrane, where a band appears at the control line, with little to no binding between the DNA probes and aptamer nanoparticles at the test line.
                </p>
                <p>Conversely, if bevacizumab is absent in the sample, the aptamer-linked gold nanoparticles will bind to the DNA probes at both the test line and the control line as the solution flows down the membrane, resulting in the appearance of two bands, indicating a negative detection of bevacizumab.

                </p>
                <img src="https://static.igem.wiki/teams/5334/wiki-images/lab/ve-and-ve-schematic.webp"></img>
              </section>

              
            </div>
          }/>
        </div>
      </section>
    </div>
  );
};

export default Hardware;
//this is an untracjed copy, could just fix with Contribution.js's Hardware content paste